import { render } from "./ExamenAlert.vue?vue&type=template&id=6728b08d"
import script from "./ExamenAlert.vue?vue&type=script&lang=js"
export * from "./ExamenAlert.vue?vue&type=script&lang=js"
script.render = render

export default script